const emptyValuePlaceholder = (value: string): string => {
  if (!value) {
    return '-';
  }
  return value;
};

const formatCurrencyNumber = (value: number): string => {
  return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(value);
}

const formatCurrency = (value: string | number): string => {
  if (typeof value === 'string') {
    value = parseFloat(value);
  }
  return formatCurrencyNumber(value);
};

const formatCurrencyCents = (centValue: number): string => {
  const value = centValue / 100;
  return formatCurrencyNumber(value);
};

const formatDecimal = (value: string | number): string => {
  const fallbackValue = '0';
  if (!value) {
    return fallbackValue;
  }
  let parsedValue: string | number = value;
  if (typeof value === 'string') {
    parsedValue = parseFloat(value);
  }
  if (typeof parsedValue !== 'number' || isNaN(parsedValue)) {
    return fallbackValue;
  }
  // Be consistent with browser inputs, strip trailing zeros.
  const fixed = + parsedValue.toFixed(2);
  return '' + fixed;
};

const formatInteger = (value: number): string => {
  const formatter = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(value);
};

const formatPercentage = (value: number): string => {
  const formatter = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(value) + ' %';
}

export {
  emptyValuePlaceholder,
  formatCurrency,
  formatCurrencyCents,
  formatDecimal,
  formatInteger,
  formatPercentage
}
